import React from 'react';
import { Box, Button, Flex, IconButton, Input, InputGroup, InputRightElement, SimpleGrid, Text, useMediaQuery } from '@chakra-ui/react';
import { FaBell, FaSearch, FaHome, FaWallet, FaShoppingBasket, FaExchangeAlt, FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const restaurants = [
  { id: 1, name: 'Restaurant A', distance: '0.5 miles' },
  { id: 2, name: 'Restaurant B', distance: '1 mile' },
  { id: 3, name: 'Restaurant C', distance: '1.5 miles' },
  { id: 4, name: 'Restaurant D', distance: '0.5 miles' },
  { id: 5, name: 'Restaurant E', distance: '1 mile' },
  { id: 6, name: 'Restaurant F', distance: '1.5 miles' },
  // Add more restaurant data here
];

const UserHome = () => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");
  const [isButtonHovered, setIsButtonHovered] = React.useState(false);
    
  return (
    <Box p={4}>
      {!isMobile && (
        <Flex bg="blue.200" p={2} mt={-9} mb={4} align="center" justify="space-between">
        <Link to="/user-home">
        <Text
            size="md"
            fontWeight="semibold"
            color="white"
            _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
        >
            Home
        </Text>
        </Link>
          <Link to="/user-wallet">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Wallet
            </Text>
          </Link>
          <Link to="/user-market">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Market
            </Text>
          </Link>
          <Link to="/user-trades">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Trades
            </Text>
          </Link>
          <Link to="/user-account">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Account
            </Text>
          </Link>          
            <Link to="/user-notifications">        
                <IconButton
                    icon={<FaBell />}
                    variant="ghost"
                    colorScheme="blue"
                    aria-label="Notifications"
                />        
            </Link>    
        </Flex>
      )}

      <Button
        colorScheme="white"
        backgroundColor="blue.50"
        borderRadius="60px"
        m={4}
        p={2}
        w="fit-content"
        _hover={{ background: 'white' }}
        _focus={{ boxShadow: 'none' }}
        as="a"
        href="/user-wallet"
        >
        <Text color="blue.200">
            Balance: $100
        </Text>
      </Button>

      <InputGroup mb={4} w={["100%", "100%", "50%"]} mx="auto">
        <Input
            placeholder="Search for restaurants"
            borderRadius="45px"
            textAlign="center"
        />
        <InputRightElement>
            <FaSearch color="gray.300" />
        </InputRightElement>
        </InputGroup>

      {/* Button for Nearby Search */}
      <Flex justify="center" align="center" mb={4}>
        <Button
            size={isMobile ? "sm" : "md"}
            colorScheme="blue"
            bg='blue.200'
            onClick={() => alert("Searching nearby...")} // Replace with actual action
            onMouseEnter={() => setIsButtonHovered(true)}
            onMouseLeave={() => setIsButtonHovered(false)}
            borderRadius="75px"
            style={{
            transition: "transform 0.3s ease-in-out",
            transform: isButtonHovered ? "scale(1.05)" : "scale(1)",
            marginRight: isMobile ? 0 : "8px",
            }}
        >
            Search Nearby
        </Button>
    </Flex>

      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4}>
        {restaurants.map(restaurant => (
          <Box
            key={restaurant.id}
            bg="white"
            p={4}
            borderRadius="md"
            boxShadow="md"
            borderColor="blue.200"
            borderWidth="1px"
          >
            <Text color="blue.200" fontWeight="medium">
              {restaurant.name}
            </Text>
            <Text color="gray.500" mt={1} fontSize="sm">
              {restaurant.distance}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      {isMobile && (
        <Flex bg="blue.200" p={2} mt={4} align="center" justify="space-between" position="fixed" bottom={0} width="95%">
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-home">
                <Flex alignItems="center" flexDirection="column">
                <FaHome />
                <Text color="white" fontSize="xs" mt={1}>
                    Home
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-wallet">
                <Flex alignItems="center" flexDirection="column">
                <FaWallet />
                <Text color="white" fontSize="xs" mt={1}>
                    Wallet
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-market">
                <Flex alignItems="center" flexDirection="column">
                <FaShoppingBasket />
                <Text color="white" fontSize="xs" mt={1}>
                    Market
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-trades">
                <Flex alignItems="center" flexDirection="column">
                <FaExchangeAlt />
                <Text color="white" fontSize="xs" mt={1}>
                    Trades
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-notifications">
                <Flex alignItems="center" flexDirection="column">
                <FaBell />
                <Text color="white" fontSize="xs" mt={1}>
                    Notifications
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-account">
                <Flex alignItems="center" flexDirection="column">
                <FaUser />
                <Text color="white" fontSize="xs" mt={1}>
                    Account
                </Text>
                </Flex>
            </Link>
            </Box>
        </Flex>
        )}
        
    </Box>
  );
};

export default UserHome;
